import type { EmailDocument } from '../model/types';

/**
 * Wersja tekstowa wiadomości.
 *
 * Skrzynka w panelu pokazuje zapowiedź jako zwykły tekst, a nie HTML, więc kanał „w
 * panelu" potrzebuje tej samej treści bez znaczników. Przy okazji jest to sensowna
 * alternatywa dla klientów pocztowych z wyłączonym HTML-em.
 */
export const documentToPlainText = (doc: EmailDocument): string => doc.blocks
  .map((block) => {
    switch (block.kind) {
      case 'heading': return block.text;
      case 'text': return block.text;
      case 'list': return block.items.filter(Boolean).map((item) => `• ${item}`).join('\n');
      case 'button': return `${block.label}: ${block.href}`;
      case 'image': return block.alt ? `[${block.alt}]` : '';
      case 'footer': return block.text;
      default: return '';
    }
  })
  .filter(Boolean)
  .join('\n\n')
  .trim();
